"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormText = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var FormText = function (_a) {
    var text = _a.text, _b = _a.small, small = _b === void 0 ? true : _b, _c = _a.italic, italic = _c === void 0 ? true : _c, props = __rest(_a, ["text", "small", "italic"]);
    var css = [];
    if (italic)
        css.push('font-italic');
    if (props.className)
        css.push(props.className);
    return (jsx_runtime_1.jsx("span", __assign({ className: css.join(' ') }, props, { children: small ? jsx_runtime_1.jsx("small", { children: text }, void 0) : text }), void 0));
};
exports.FormText = FormText;
exports.FormText.Error = function (_a) {
    var text = _a.text, className = _a.className, props = __rest(_a, ["text", "className"]);
    return (jsx_runtime_1.jsx(exports.FormText, __assign({ text: text, className: className + " text-danger" }, props), void 0));
};
// Help Variant
exports.FormText.Help = function (_a) {
    var text = _a.text, props = __rest(_a, ["text"]);
    return (jsx_runtime_1.jsx(exports.FormText, __assign({ text: text }, props), void 0));
};
//# sourceMappingURL=index.js.map